import changeTotalClassicAttachmentSize from './changeTotalClassicAttachmentSize';
import AttachmentWellViewState from '../schema/AttachmentWellViewState';
import { AttachmentModelPropertyValues } from 'owa-attachment-model-store';
import addAndInitializeAttachments from 'owa-attachment-model-store/lib/actions/addAndInitializeAttachments';
import shouldShowImageView from 'owa-attachment-model-store/lib/utils/shouldShowImageView';
import { ClientAttachmentId } from 'owa-client-ids';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import { action } from 'satcheljs/lib/legacy';
import {
    AttachmentFullViewState,
    AttachmentState,
    isInlineAttachmentStateType,
} from 'owa-attachment-full-data';

export default action('addAttachmentIntoWellBeforeUpload')(
    function addAttachmentIntoWellBeforeUpload(
        attachmentState: AttachmentState,
        attachmentWellViewState: AttachmentWellViewState,
        attachment: AttachmentType,
        tempId: ClientAttachmentId,
        modelPropertyInitializationValues: AttachmentModelPropertyValues = null
    ) {
        attachment.AttachmentId = tempId;
        addAndInitializeAttachments(
            [
                {
                    attachmentId: {
                        ...attachment.AttachmentId,
                        mailboxInfo: tempId.mailboxInfo,
                    },
                    attachment: attachment,
                    modelInitializationValues: modelPropertyInitializationValues,
                },
            ],
            false /* isReadOnly */,
            true /* forceAdd */,
            true /* skipInitialization */
        );

        let isInline: boolean;
        if (isInlineAttachmentStateType(attachmentState)) {
            attachmentWellViewState.inlineAttachments.push(attachmentState);
            isInline = true;
        } else {
            // As we are adding attachment before uploading so it is still a placeholder attachment
            attachmentState.isPlaceholderAttachment = true;

            if (shouldShowImageView(attachment)) {
                attachmentWellViewState.imageViewAttachments.push(attachmentState);
            } else {
                attachmentWellViewState.docViewAttachments.push(attachmentState);
            }
        }

        if (isInline || !(<AttachmentFullViewState>attachmentState).isCloudy) {
            changeTotalClassicAttachmentSize(attachmentWellViewState, attachment.Size);
        }
    }
);
